import React from "react";
import Navbar from "./navbar";
import HomeHeroSection from "./HomeHeroSection";
import Product from "./Product";
import AIExpertise from "./AIExpertise";
import Clients from "./Clients";
import OurServices from "./OurServices";
import WhyChooseUs from "./WhyChooseUs";
import Technologies from "./Technologies";
import Footer from "./Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-clip">
      <Navbar />
      <HomeHeroSection />
      <Product />
      <AIExpertise />
      <Clients />
      <OurServices />
      <WhyChooseUs />
      <Technologies />
      <Footer />
    </div>
  );
}